import { AuthContext } from "@/Context/Auth";
import { useContextSelector } from "use-context-selector";

export const useUserData = () => {
  const userData = useContextSelector(AuthContext, v => v.state.userData);

  return userData;
};

